import * as i0 from '@angular/core';
import { input, booleanAttribute, computed, Component, NgModule } from '@angular/core';

class BrnSeparatorComponent {
    orientation = input('horizontal');
    decorative = input(false, { transform: booleanAttribute });
    role = computed(() => (this.decorative() ? 'none' : 'separator'));
    ariaOrientation = computed(() => this.decorative() ? undefined : this.orientation() === 'vertical' ? 'vertical' : undefined);
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.5", type: BrnSeparatorComponent, isStandalone: true, selector: "brn-separator", inputs: { orientation: { classPropertyName: "orientation", publicName: "orientation", isSignal: true, isRequired: false, transformFunction: null }, decorative: { classPropertyName: "decorative", publicName: "decorative", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "role": "role()", "attr.aria-orientation": "ariaOrientation()", "attr.data-orientation": "orientation()" } }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'brn-separator',
                    standalone: true,
                    template: '',
                    host: {
                        '[role]': 'role()',
                        '[attr.aria-orientation]': 'ariaOrientation()',
                        '[attr.data-orientation]': 'orientation()',
                    },
                }]
        }] });

class BrnSeparatorModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorModule, imports: [BrnSeparatorComponent], exports: [BrnSeparatorComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.5", ngImport: i0, type: BrnSeparatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [BrnSeparatorComponent],
                    exports: [BrnSeparatorComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BrnSeparatorComponent, BrnSeparatorModule };
